import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Lock } from 'lucide-react';
interface CTAButtonProps {
  mainText: string;
  subText?: string;
  onClick?: () => void;
  className?: string;
}
export function CTAButton({
  mainText,
  subText,
  onClick,
  className = ''
}: CTAButtonProps) {
  return <div className={`relative group ${className}`} data-id="element-428">
      {/* Pulsing Ring */}
      <div className="absolute inset-0 rounded-xl bg-[#C1440E] opacity-20 animate-pulse-ring z-0" data-id="element-429"></div>

      <motion.button whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} onClick={onClick || (() => document.getElementById('final-cta')?.scrollIntoView({
      behavior: 'smooth'
    }))} className="relative w-full overflow-hidden bg-gradient-to-r from-[#C1440E] to-[#9a3409] text-white rounded-xl p-4 md:p-6 shadow-xl border-b-4 border-[#7a2907] active:border-b-0 active:translate-y-1 transition-all z-10 min-h-[80px]" data-id="element-430">
        {/* Shimmer Effect */}
        <div className="absolute inset-0 -translate-x-full group-hover:animate-shimmer bg-gradient-to-r from-transparent via-white/20 to-transparent z-20" data-id="element-431" />

        <div className="flex flex-col items-center justify-center text-center relative z-30" data-id="element-432">
          <span className="text-xl md:text-3xl font-bold uppercase tracking-wide flex items-center gap-2 drop-shadow-md" data-id="element-433">
            {mainText}
            <motion.div animate={{
            x: [0, 5, 0]
          }} transition={{
            repeat: Infinity,
            duration: 1.5
          }} data-id="element-434">
              <ArrowRight className="w-6 h-6 md:w-8 md:h-8" data-id="element-435" />
            </motion.div>
          </span>
          {subText && <span className="text-sm md:text-base opacity-95 mt-1 font-medium text-yellow-50" data-id="element-436">
              {subText}
            </span>}
        </div>
      </motion.button>

      {/* Trust Line */}
      <div className="mt-3 flex items-center justify-center gap-2 text-xs text-[#2C1810]/70 font-medium" data-id="element-437">
        <Lock className="w-3 h-3" data-id="element-438" />
        <span data-id="element-439">Pago 100% seguro · Descarga inmediata</span>
      </div>
    </div>;
}